import * as GiftValue from '../../constants/giftValue';
import * as DisclosureType from '../../constants/disclosureType';
import * as ResponsibleOfficerType from '../../constants/responsibleOfficerType';
import BaseAssessmentController from '../base-assessment.controller';

class GiftAssessmentController extends BaseAssessmentController {
    constructor(preFetchedData, componentRegistryService, componentDataService, disclosureService, loggerService, $state, $q, constants, assessmentService, _, fileSaver) {
        super('GiftAssessmentController', DisclosureType.Gift, disclosureService, _, preFetchedData, $q, $state, componentRegistryService, componentDataService, assessmentService, fileSaver, loggerService);
        this.lineManager = preFetchedData.lineManager;
        this.alternativeOfficer = preFetchedData.alternativeOfficer;
        this.executiveManagers = preFetchedData.alternativeOfficer ? [preFetchedData.alternativeOfficer] : [];
        this.managementStrategies = this._.filter(preFetchedData.managementStrategies, (cat) => cat.type !== "Conflict");
        this.giftApprovalOfficerType =  this._getGiftApprovalOfficerType(this.disclosureData.giftDetail.giftValue, this.disclosureData.giftDetail.totalValueOfGifts);
        this.acknowledgements = [
            {
                id: "appropriateActionOk", 
                text: `I have determined the most appropriate action for the above gift disclosure after referring to 
                            <a href="${constants.Links.Procedures}" target="_blank">Conflict of Interest Procedures</a> 
                            and Section 6 of <a href="${constants.Links.Appendix1}" target="_blank">Appendix 1</a>.`}
        ];
        this.giftStatus = this.disclosureData.status;
        this.commentRequiredSubmit = () => {
            let managementStrategy = this.componentRegistryService.get("managementStrategy");

            if (managementStrategy && managementStrategy.model.selectedOption) {
                return managementStrategy.model.selectedOption.id !== "DiscloserAccept";
            }

            if (managementStrategy && managementStrategy.model.selectedOption === undefined) {
                return true;
            }

            return false;
        };

        this.onManagementStrategyRequired = (managementStrategyRequired) => {
            this.showReturnDisclosureInput = this.showReturnCommentsInput(managementStrategyRequired);
            super.toggleAcknowledgements(managementStrategyRequired, this.disclosureData.type);
        }
    }

    showAcknowledgements(dislosureStatus, showAcknowledgementsSection = this.showAcknowledgementsSection) {
        return dislosureStatus === 'PendingAssessment' && showAcknowledgementsSection;
    }

    _getGiftApprovalOfficerType(giftValue, totalValueOfGifts) {
        if (totalValueOfGifts) {
            return ResponsibleOfficerType.ExecutiveManager;
        }
        let value = this._.toInteger(giftValue);
        if (value > GiftValue.ExecutiveGiftValue) {
            return ResponsibleOfficerType.ExecutiveManager;
        }
        if (value > GiftValue.MinimumGiftValue) {
            if (this.alternativeOfficer) {
                return ResponsibleOfficerType.AlternativeOfficer;
            }
            return  ResponsibleOfficerType.LineManager;
        }
        return "";
    }

    isProgressingAssessment() {
        return this._.get(this.componentRegistryService.get("managementStrategy"), "model.selectedOption");
    }
}

GiftAssessmentController.$inject = ['preFetchedData', 'componentRegistryService', 'componentDataService', 'disclosureService', 'loggerService', '$state', '$q', 'constants', 'assessmentService', '_', 'FileSaver'];

export default GiftAssessmentController;


// WEBPACK FOOTER //
// ./app/assess/gift/gift-assessment.controller.js